import { render, staticRenderFns } from "./purchase-form.html?vue&type=template&id=12b532f7&scoped=true&external"
import script from "./purchase-form.js?vue&type=script&lang=js&external"
export * from "./purchase-form.js?vue&type=script&lang=js&external"
import style0 from "./purchase-form.scss?vue&type=style&index=0&id=12b532f7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b532f7",
  null
  
)

export default component.exports